<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="c08"><a id="page09"></a>Matching Ring and Bracelet</h1>
<p class="nonindent"><span class="dropcaps">R</span>aymond Rashawne Carter proposed to his girlfriend in February 2005 and then surprised her with a beautiful set of wedding rings worth $1,500. She accepted his proposal, and he slipped the ring on her finger, but it was a little big. The unfazed fiancé decided to return the rings and have them resized. At the Charlottesville, Virginia, store, the clerk took the ring and then gave the police a ring. Apparently, Raymond forgot to mention that he didn’t pay for the jewelry. So procuring the ring at a five-finger discount in order to adorn his girlfriend’s ring finger, Raymond fingered himself, and I’m sure his girlfriend gave him the finger for his efforts.<img alt="" src="OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"/></p>
<div class="block">
<p class="center"><img alt="" src="OEBPS/images/Greg_9780740792069_epub_L02_r1.jpg"/></p>
<p class="center"><em><strong>When Ruth and Kevin Kimber married in 1990, she was ninety-three and he was twenty-eight.</strong></em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792069_epub_c08_r1.vue?8cef4898